<template>
  <ContentSection permissions="Feedback and Complaint" :detail="detail" @on-revision="handleRevision"
    @on-approve="handleApprove" @on-close="handleClose"
    approval-title="Investigation Request Process (Tech Mkt Supp Manager)" nextStep="Investigation Internal Issue"
    revision-from-text="Tech Mkt Supp Manager">
    <template #initial-form>
      <div>
        <div v-permissions="'Create Temporary Solution on Feedback and Complaint'" v-if="!detail?.tmp_solution"
          class="white-box mm15 p30 mb-3" style="min-height: auto;">
          <div class="popup-item p-0">
            <div class="row">
              <div class="col-sm-12">
                <div class="d-flex flex-row justify-content-between align-items-center mb-4">
                  <div class="ft-16 font-bold">Temporary Solution (Tech Sales Supp)</div>
                </div>
                <button @click="$router.push(`/feedback/${$route.params.id}/temporary-solution`)"
                  class="btn btn-orange w-100">Input Temporary Solution</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #submitted-form="{ toggleCollapse, isCollapse, openModal, closeModal, modal }">
      <div v-if="detail?.tmp_solution" class="white-box mm15 p30 mb-3" style="min-height: auto;">
        <div class="popup-item p-0">
          <div class="row">
            <div class="col-sm-12">
              <div class="d-flex flex-row justify-content-between align-items-center">
                <div class="ft-16 font-bold">Temporary Solution (Tech Sales Supp)</div>
                <button @click="toggleCollapse" class="btn btn-transparent" :class="{ 'rotate': isCollapse }"><span
                    class="icon-ico-arrow-down"></span></button>
              </div>
              <div class="card-content" :class="{ 'show': isCollapse }">
                <div class="popup-item wb">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="grey">Problem Cause</div>
                      <div>{{ detail?.tmp_solution }}
                      </div>
                    </div>
                  </div>
                </div>
                <button @click="openModal('detail')" class="btn btn-see ft-14 mt-3">
                  Show detail
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Detail Modal -->
        <div class="popup-wrapper" :class="{ 'showing': modal.detail }">
          <div class="popup-card p25">
            <div class="d-flex justify-content-between align-items-center">
              <div class="font-bold">Temporary Solution (Tech Sales Supp)</div>
              <button @click="closeModal('detail')" class="btn btn-for-close"><span
                  class="icon-ico-close"></span></button>
            </div>
            <div class="inner-land">
              <div class="popup-item">
                <div class="row gap-2">
                  <div v-if="detail?.attachment_solution !== ''" class="col-sm-12">
                    <div class="grey">Attach File</div>
                    <component :is="isImage(detail?.attachment_solution) ? 'img' : 'a'"
                      :src="isImage(detail?.attachment_solution) ? detail?.attachment_solution : null"
                      :href="!isImage(detail?.attachment_solution) ? detail?.attachment_solution : null" target="_blank"
                      rel="noopener" v-bind="componentAttrs">
                      <template v-if="!isImage(detail?.attachment_solution)">
                        Download File
                      </template>
                    </component>
                  </div>
                  <div class="col-sm-12">
                    <div class="grey">Problem Cause</div>
                    <div>{{ detail?.tmp_solution }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #cta-edit-form>
      <div>
        <button v-permissions="'Create Temporary Solution on Feedback and Complaint'"
          @click="$router.push(`/feedback/${$route.params.id}/temporary-solution/edit`)"
          class="btn btn-orange mm15 w-100">Edit Temporary Solution</button>
      </div>
    </template>
  </ContentSection>
</template>
<script>
import ContentSection from '../Content'
import axios from '@/axios';
import { showErrorMessage } from '@/utils';
export default {
  name: "FNCDetailTemporarySolution",
  components: {
    ContentSection,
  },
  methods: {
    async handleRevision(payload) {
      try {
        this.$store.dispatch('toggleLoadingProgress', true)
        await axios.put(`/fnc/${this.$route.params.id}/update-status`, {
          status: 'revision',
          revision: payload.reason
        })
        this.$notify({ type: 'success', text: 'Revision sent!' })
        if (payload.callback) payload.callback()
        this.$store.dispatch('getDetailFeedbackComplaint', this.$route.params.id)
      } catch (error) {
        showErrorMessage(error)
      } finally {
        this.$store.dispatch('toggleLoadingProgress', false)
      }
    },
    async handleApprove(payload) {
      try {
        this.$store.dispatch('toggleLoadingProgress', true)
        await axios.put(`/fnc/${this.$route.params.id}/update-status`, {
          status: 'approved',
        })
        this.$notify({ type: 'success', text: 'Feedback Approved!' })
        if (payload.callback) payload.callback()
        this.$store.dispatch('getDetailFeedbackComplaint', this.$route.params.id)
      } catch (error) {
        showErrorMessage(error)
      } finally {
        this.$store.dispatch('toggleLoadingProgress', false)
      }
    },
    async handleClose(payload) {
      try {
        this.$store.dispatch('toggleLoadingProgress', true)
        await axios.put(`/fnc/${this.$route.params.id}/update-status`, {
          status: 'closed',
        })
        this.$notify({ type: 'success', text: 'Feedback Closed!' })
        if (payload.callback) payload.callback()
        this.$store.dispatch('getDetailFeedbackComplaint', this.$route.params.id)
      } catch (error) {
        showErrorMessage(error)
      } finally {
        this.$store.dispatch('toggleLoadingProgress', false)
      }
    },
    isImage(url) {
      return /\.(jpeg|jpg|gif|png|webp|bmp|svg)$/i.test(url);
    }
  },
  computed: {
    // Optional: you can provide attributes conditionally
    componentAttrs() {
      return this.isImage(this.detail?.attachment_solution)
        ? { alt: 'Image Preview', style: 'max-width: 50%; height: auto;' }
        : {};
    },
    detail() {
      return this.$store.state?.feedbackComplaint?.detail
    },
  }
}
</script>
